import { useState } from 'react'
import { Translate } from 'react-redux-i18n'
import * as XLSX from 'xlsx'
import { SizeTracker } from '../../../../../common/SizeTracker'
import { UseI18n } from '../../../../../common/hooks/useI18n'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import { PopupAction } from '../../../../../common/popup/PopupAction'
import TextEllipsis from '../../../../../common/textEllipsis'
import { formatJsonDataFromExcel } from '../../../../../helpers/export'
import classes from './index.module.scss'

export const PopupImportFile = ({ isShow, setShow, onApply }) => {
  const [dataImport, setDataImport] = useState([])

  const handleCancel = () => {
    setShow(false)
  }

  const handleApply = () => {
    if (dataImport) {
      onApply(dataImport)
    }
    setShow(false)
  }

  return (
    <div>
      {isShow && (
        <PopupAction
          appendStyle={{
            width: 608,
            padding: '20px',
            backgroundColor: '#F3F3F3',
            borderRadius: '4px',
          }}
          isShow={isShow}
          title="common.IMPORT_FILE"
          handleClose={handleCancel}
          btnSubmit={{
            label: 'common.APPLY',
            event: handleApply,
            disabled: !dataImport.length ? true : false,
            isI18n: true,
          }}
          btnCancel={{
            label: 'common.CANCEL',
            event: handleCancel,
            isI18n: true,
          }}
        >
          <UploadFile setDataImport={setDataImport} />
        </PopupAction>
      )}
    </div>
  )
}

const UploadFile = ({ setDataImport }) => {
  const [fileName, setFileName] = useState('')
  const [invalidFormatFile, setInvalidFormatFile] = useState(false)

  const textInput = UseI18n('screening.NO_CHOOSE_FILE')

  const handleConvert = (file) => {
    if (file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        const data = e.target.result
        const workbook = XLSX.read(data, { type: 'binary' })
        const sheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[sheetName]
        const json = XLSX.utils.sheet_to_json(worksheet)
        setDataImport(formatJsonDataFromExcel(json))
      }
      reader.readAsBinaryString(file)
    }
  }

  const handleSelectFile = (event) => {
    const validExts = ['.xlsx', '.xls']
    const fileExt = event.target.files[0].name.substring(
      event.target.files[0].name.lastIndexOf('.'),
    )
    if (!validExts.includes(fileExt)) {
      setInvalidFormatFile(true)
    } else {
      handleConvert(event.target.files[0])
      setFileName(event.target.files[0]?.name)
      setInvalidFormatFile(false)
    }
  }

  return (
    <div>
      <>
        <div className={classes.groupUpload}>
          <div className="dFlex flex1">
            <Element
              elementName="label"
              style={{
                color: '#FFFFFF',
                padding: '0 24px',
                backgroundColor: '#2C73E8',
                borderRadius: '4px',
                textAlign: 'center',
              }}
              htmlFor="importFile"
              className="whiteSpaceNowrap cursorPointer dFlex justifyContentCenter alignItemsCenter"
            >
              <Translate value="screening.CHOOSE_FILE" />
            </Element>
            <Element
              style={{ backgroundColor: '#FFFFFF' }}
              className={classes.inputChooseFile}
            >
              <Icon
                className="icon-insert-file"
                style={{ color: '#9C9C9C', fontSize: 14 }}
              />
              <SizeTracker
                bottomClassName="flex1"
                renderBottomComponent={(size) => {
                  return (
                    <TextEllipsis
                      text={fileName ? fileName : textInput}
                      isI18n={false}
                      appendStyle={{
                        color: '#9C9C9C',
                        width: size?.width,
                      }}
                      zIndexTooltip={15}
                    />
                  )
                }}
              />
            </Element>
          </div>
          <Element
            elementName="a"
            style={{
              color: '#2C73E8',
              lineHeight: '28px',
              cursor: 'pointer',
            }}
            className="whiteSpaceNowrap"
            href="/templates/FiinGate_ImportTaxCode.xlsx"
            download="FiinGate_ImportTaxCode.xlsx"
          >
            <Translate value="screening.DOWNLOAD_TEMPLATE" />
          </Element>
        </div>
      </>
      {invalidFormatFile && (
        <Element
          className={classes.validateUpload}
          style={{ backgroundColor: '#F5E6E7', borderColor: '#E0505B' }}
        >
          <Element>
            <Element
              elementName="p"
              style={{
                color: '#E0505B',
                fontStyle: 'italic',
                padding: '1px 0',
              }}
            >
              <Translate value="screening.VALIDATE_FORMAT_FILE" />
            </Element>
          </Element>
        </Element>
      )}
      <input
        type="file"
        name="importFile"
        id="importFile"
        onChange={handleSelectFile}
        style={{ display: 'none' }}
      />
    </div>
  )
}
